import { createSlice } from '@reduxjs/toolkit';
import reducers from './reducers';
import extraReducers from './extraReducers';

export * from '../../thunk/aavOrders';

const AavOrdersSlice = createSlice({
    name: 'aavOrders',
    initialState: {
        list: [] as any[],
        singleOrder: null as any,
        status: null as string | null,
        singleStatus: null as string | null,
        error: null as string | null,
        singleError: null as string | null,
        queryParams: {
            page: 1,
            limit: 50,
            sortDirection: 'DESC',
            statusId: null,
            search: null,
            tags: null,
            createdAtMin: null,
            createdAtMax: null,
            total: 0,
        } as any,
    },
    reducers,
    extraReducers,
});

const { actions, reducer } = AavOrdersSlice;
export const { clearAavOrdersFilters, setAavOrdersList } = actions;
export { reducer };
